import React, { useContext } from "react";
import RateButtonGroup from "../../../../components/shared/InputElements/RateButtonGroup";
import UserPrefsContext from "../../../../context/UserPrefs/UserPrefsContext";

const ButtonGroupChargingPatterns = ({
  id = "btn-group-charging-patterns",
  label = "",
  chargingPatterns,
  monthChargingPatternsId,
  ...rest
}) => {
  const userPrefs = useContext(UserPrefsContext);
  const idKey = monthChargingPatternsId ? monthChargingPatternsId : 'chargingPatternId'; 
  const chargingPatternId = userPrefs.get(idKey);

  return (
    <div className="ButtonGroupChargingPatterns">
      <RateButtonGroup
        id={id}
        value={chargingPatternId}
        label={label}
        chargingPatterns={chargingPatterns}
        handler={(e, selected) =>
          userPrefs.set({ [idKey]: selected })
        }
        {...rest}
      />
    </div>
  );
};

export default ButtonGroupChargingPatterns;
